/* eslint-disable no-secrets/no-secrets */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import QuotePage from 'twia-capability-quoteandbind-cp-react/pages/Quote/QuotePage.jsx';
import { PolicyDetailsPage, PaymentDetailsPage } from 'twia-capability-renewal-common-react';
import CoverageSummaryPage from './pages/CoverageSummary/CoverageSummaryPage.jsx';
import AdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage.jsx';
import BuildingsAndLocationsPage from './pages/BuildingsAndLocations/BuildingsAndLocationsPage.jsx';

setComponentMapOverrides(
    {
        TWIARenewalCPPolicyDetailsPage: { component: 'TWIARenewalCPPolicyDetailsPage' },
        TWIARenewalCPBuildingsAndLocationsPage: { component: 'TWIARenewalCPBuildingsAndLocationsPage' },
        TWIARenewalCPQuotePage: { component: 'TWIARenewalCPQuotePage' },
        TWIARenewalCPAdditionalInformationPage: { component: 'TWIARenewalCPAdditionalInformationPage' },
        TWIARenewalCPCoverageSummaryPage: { component: 'TWIARenewalCPCoverageSummaryPage' },
        TWIARenewalCPPaymentDetailsPage: { component: 'TWIARenewalCPPaymentDetailsPage' }

    },
    {
        TWIARenewalCPPolicyDetailsPage: PolicyDetailsPage,
        TWIARenewalCPBuildingsAndLocationsPage: BuildingsAndLocationsPage,
        TWIARenewalCPQuotePage: QuotePage,
        TWIARenewalCPAdditionalInformationPage: AdditionalInformationPage,
        TWIARenewalCPCoverageSummaryPage: CoverageSummaryPage,
        TWIARenewalCPPaymentDetailsPage: PaymentDetailsPage
    }
)

export { default as TWIACommercialRenewalWizard } from './TWIACommercialRenewalWizard.jsx';
